import React, { useContext } from 'react'
import styled, { ThemeContext, ThemeProvider } from 'styled-components'
import { colors } from '@jarvis.oddle/core/theme/default'
import { getBlocksDataFromSectionData } from '@jarvis.oddle/core/tools/customisation'
import CustomisationContent from './CustomisationContent'
import { selectDetailMenuSite } from 'src/redux/meta'
import useAppSelector from 'src/hooks/useAppSelector'
import { newsletterSignupAction } from 'src/redux/newsletter'
import useAppDispatch from 'src/hooks/useAppDispatcher'
import useTracker from 'src/hooks/useTracker'
import BasicContent from './BasicContent'
import { useRouter } from 'next/router'
import ResponsiveSection from 'src/components/core/ResponsiveSection'
import { isEmpty } from 'src/utils/string'

const StyledResponsiveSection = styled(ResponsiveSection)`
  margin-top: 0;
  margin-bottom: 0;
  background-color: ${(props) =>
    props.theme.colorBackgroundColor || colors.footerBackground};
`

const Footer = (): JSX.Element => {
  const router = useRouter()
  const theme = useContext(ThemeContext)
  const dispatch = useAppDispatch()
  const { notifyNewsletterCompleteRegistration } = useTracker()

  const metaState = useAppSelector(selectDetailMenuSite)
  const { locales } = metaState
  const { previewMode, sectionSettingData } = useAppSelector(
    (state) => state['@customisation'].data
  )
  const blocksData = getBlocksDataFromSectionData(
    sectionSettingData?.sections?.['footer'] || {}
  )
  const { settings = {} } = sectionSettingData?.sections?.['footer'] || {}
  const { navigationLinkFontColor, footerBackgroundColor } = settings
  const footerTheme = {
    ...theme,
    colorHeadingsFont: navigationLinkFontColor,
    colorBodyFont: navigationLinkFontColor,
    colorBackgroundColor: footerBackgroundColor,
    buttonColor: navigationLinkFontColor,
    colorLinesAndBorders: navigationLinkFontColor
  }

  const handleSubmitNewsletter = async (params) => {
    const response = await dispatch(newsletterSignupAction(params))
    if (response.meta.requestStatus === 'fulfilled' && isEmpty(response.payload.errors)) {
      notifyNewsletterCompleteRegistration(params)
    }
    return response
  }

  return (
    <ThemeProvider theme={footerTheme}>
      <StyledResponsiveSection id='oddle-shop-footer'>
        <ResponsiveSection.Container>
          <CustomisationContent
            blocksData={blocksData}
            previewMode={previewMode}
            newsletterSignupAction={handleSubmitNewsletter}
          />
          <BasicContent
            previewMode={previewMode}
            locales={locales}
            locale={router.query.locale as string}
          />
        </ResponsiveSection.Container>
      </StyledResponsiveSection>
    </ThemeProvider>
  )
}

export default Footer
